/**
 * @generated SignedSource<<db6c0abdd6d93b8d0fed4fac921c939c>>
 * @relayHash 32a17639683e9787cd0d4b3e77e4a25d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b35ac2c9fb6cf1ee425dc5e7f3398eec80f51f8cc50e9d8213ade874f62c00a1

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraMoveVersionToStartInput = {
  id: string;
};
export type table_moveVersionToStartMutation$variables = {
  input: JiraMoveVersionToStartInput;
};
export type table_moveVersionToStartMutation$data = {
  readonly jira: {
    readonly moveJiraVersionToStart: {
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type table_moveVersionToStartMutation = {
  response: table_moveVersionToStartMutation$data;
  variables: table_moveVersionToStartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraUpdateVersionPayload",
        "kind": "LinkedField",
        "name": "moveJiraVersionToStart",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "table_moveVersionToStartMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "table_moveVersionToStartMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "b35ac2c9fb6cf1ee425dc5e7f3398eec80f51f8cc50e9d8213ade874f62c00a1",
    "metadata": {},
    "name": "table_moveVersionToStartMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "77939c4fcd78faef0ac2c9e07c8398a6";

export default node;
